import * as React from 'react';
import { FC, useState } from 'react';
import useInputErrorsDebouncer from 'app/useInputErrorsDebouncer';
import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';
import type { Values, ChangeValues, Errors } from './types';
import PasswordIcon from './images/icon_password.svg';
import { PASSWORD_INPUT_PATTERN } from './usePasswordValidation';

const Password: FC<{
  values: Values;
  changeValues: ChangeValues;
  errors: Errors;
  locales: Locales;
}> = ({ values, changeValues, errors, locales }) => {
  const [visible, setVisible] = useState(false);
  const { password } = values;
  const passwordErrors = errors.password || [];
  const [canShowErrors, delayErrors] = useInputErrorsDebouncer();
  const showErrors = password && canShowErrors;

  return (
    <div className={`input player_password ${showErrors && passwordErrors.length ? 'error' : ''}`}>
      <div className="input-with-icon xo-form_input-iconfull">
        <input
          autoComplete="new-password"
          placeholder={translation(locales, 'password.placeholder')}
          type={visible ? 'text' : 'password'}
          name="player[password]"
          id="player_password"
          className="sign_input xo-form_input"
          value={password}
          onChange={(e) => {
            const pass = e.target.value;
            if (PASSWORD_INPUT_PATTERN.test(pass)) {
              changeValues({ password: pass });
              delayErrors();
            }
          }}
        />
        <label htmlFor="player_password" className="xo-form_input-label">
          <span className="xo-form_label-placeholder">{translation(locales, 'password.placeholder')}</span>
          <span className="xo-form_input-image">
            <img src={PasswordIcon} alt="icon" />
          </span>
        </label>
        <span className="icon" />
        {password && (
          <i
            onClick={() => setVisible((v) => !v)}
            className={`visibility rs-icon-${visible ? 'eye' : 'eye-slash'}`}
            title={visible ? 'hide' : 'show'}
          />
        )}
      </div>
      <div className="hints">
        {[translation(locales, 'password.hint'), translation(locales, 'password.must_not_eq_login')].map((error) => (
          <small key={error} className={showErrors && passwordErrors.includes(error) ? 'error' : 'hint'}>
            {error}
          </small>
        ))}
      </div>
    </div>
  );
};

export default Password;
